import React from 'react';
import PropTypes from 'prop-types';

import PriceBreakdownRow from './PriceBreakdownRow';

const propTypes = {
  className: PropTypes.string,
};

const LoadingPlaceholder = ({ className }) => {
  const rows = ['Subtotal', 'Taxes', 'Shipping', 'Total'];

  return (
    <div className={className}>
      {rows.map(row => (
        <PriceBreakdownRow key={row} label={row} currencySymbol="$" value={0} />
      ))}
    </div>
  );
};

LoadingPlaceholder.propTypes = propTypes;

export default LoadingPlaceholder;
